import { Action } from '@ngrx/store'
import * as businessCategoriesTypes from './business-categories.types'
import {
  BusinessCategory,
  BusinessSubcategory,
} from './business-categories.interface'

export class FetchBusinessCategoriesRequest implements Action {
  readonly type = businessCategoriesTypes.FETCH_BUSINESS_CATEGORIES_REQUEST
  constructor(public payload: any = {}) {}
}

export class FetchBusinessCategoriesSuccess implements Action {
  readonly type = businessCategoriesTypes.FETCH_BUSINESS_CATEGORIES_SUCCESS
  constructor(
    public payload: BusinessCategory[],
    public total: number,
    public results?: number,
  ) {}
}

export class FetchBusinessCategoriesFailure implements Action {
  readonly type = businessCategoriesTypes.FETCH_BUSINESS_CATEGORIES_FAILURE
  constructor(public payload: any) {}
}

export class FetchBusinessCategoryRequest implements Action {
  readonly type = businessCategoriesTypes.FETCH_BUSINESS_CATEGORY_REQUEST
  constructor(public id: number, public params?: any) {}
}

export class FetchBusinessCategorySuccess implements Action {
  readonly type = businessCategoriesTypes.FETCH_BUSINESS_CATEGORY_SUCCESS
  constructor(public payload: BusinessCategory) {}
}

export class FetchBusinessCategoryFailure implements Action {
  readonly type = businessCategoriesTypes.FETCH_BUSINESS_CATEGORY_FAILURE
  constructor(public payload: any) {}
}

export class DeleteBusinessCategoryRequest implements Action {
  readonly type = businessCategoriesTypes.DELETE_BUSINESS_CATEGORY_REQUEST
  constructor(public id: number) {}
}

export class DeleteBusinessCategorySuccess implements Action {
  readonly type = businessCategoriesTypes.DELETE_BUSINESS_CATEGORY_SUCCESS
  constructor() {}
}

export class DeleteBusinessCategoryFailure implements Action {
  readonly type = businessCategoriesTypes.DELETE_BUSINESS_CATEGORY_FAILURE
  constructor(public payload: any) {}
}

export class CreateBusinessCategoryRequest implements Action {
  readonly type = businessCategoriesTypes.CREATE_BUSINESS_CATEGORY_REQUEST
  constructor(public payload, public redirect: boolean) {}
}

export class CreateBusinessCategorySuccess implements Action {
  readonly type = businessCategoriesTypes.CREATE_BUSINESS_CATEGORY_SUCCESS
  constructor() {}
}

export class CreateBusinessCategoryFailure implements Action {
  readonly type = businessCategoriesTypes.CREATE_BUSINESS_CATEGORY_FAILURE
  constructor(public payload: any) {}
}

export class UpdateBusinessCategoryRequest implements Action {
  readonly type = businessCategoriesTypes.UPDATE_BUSINESS_CATEGORY_REQUEST
  constructor(public id: number, public payload) {}
}

export class UpdateBusinessCategorySuccess implements Action {
  readonly type = businessCategoriesTypes.UPDATE_BUSINESS_CATEGORY_SUCCESS
  constructor() {}
}

export class UpdateBusinessCategoryFailure implements Action {
  readonly type = businessCategoriesTypes.UPDATE_BUSINESS_CATEGORY_FAILURE
  constructor(public payload: any) {}
}

// Common

export class UpdateField implements Action {
  readonly type = businessCategoriesTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class CreateBusinessSubcategoryRequest implements Action {
  readonly type = businessCategoriesTypes.CREATE_BUSINESS_SUBCATEGORY_REQUEST
  constructor(public id: number, public payload: any) {}
}

export class CreateBusinessSubcategorySuccess implements Action {
  readonly type = businessCategoriesTypes.CREATE_BUSINESS_SUBCATEGORY_SUCCESS
  constructor() {}
}

export class CreateBusinessSubcategoryFailure implements Action {
  readonly type = businessCategoriesTypes.CREATE_BUSINESS_SUBCATEGORY_FAILURE
  constructor(public payload: any) {}
}

export class SetDefaultData implements Action {
  readonly type = businessCategoriesTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export class DeleteBusinessSubcategoryRequest implements Action {
  readonly type = businessCategoriesTypes.DELETE_BUSINESS_SUBCATEGORY_REQUEST
  constructor(public cid: number, public id: number) {}
}

export class DeleteBusinessSubcategorySuccess implements Action {
  readonly type = businessCategoriesTypes.DELETE_BUSINESS_SUBCATEGORY_SUCCESS
  constructor() {}
}

export class DeleteBusinessSubcategoryFailure implements Action {
  readonly type = businessCategoriesTypes.DELETE_BUSINESS_SUBCATEGORY_FAILURE
  constructor(public payload: any) {}
}

export class FetchBusinessSubcategoryRequest implements Action {
  readonly type = businessCategoriesTypes.FETCH_BUSINESS_SUBCATEGORY_REQUEST
  constructor(public id: number, public params?: any) {}
}

export class FetchBusinessSubcategorySuccess implements Action {
  readonly type = businessCategoriesTypes.FETCH_BUSINESS_SUBCATEGORY_SUCCESS
  constructor(public payload: BusinessSubcategory) {}
}

export class FetchBusinessSubcategoryFailure implements Action {
  readonly type = businessCategoriesTypes.FETCH_BUSINESS_SUBCATEGORY_FAILURE
  constructor(public payload: any) {}
}

export class UpdateBusinessSubcategoryRequest implements Action {
  readonly type = businessCategoriesTypes.UPDATE_BUSINESS_SUBCATEGORY_REQUEST
  constructor(public cid: number, public id: number, public payload) {}
}

export class UpdateBusinessSubcategorySuccess implements Action {
  readonly type = businessCategoriesTypes.UPDATE_BUSINESS_SUBCATEGORY_SUCCESS
  constructor() {}
}

export class UpdateBusinessSubcategoryFailure implements Action {
  readonly type = businessCategoriesTypes.UPDATE_BUSINESS_SUBCATEGORY_FAILURE
  constructor(public payload: any) {}
}

export type Actions =
  | UpdateBusinessCategoryRequest
  | UpdateBusinessCategorySuccess
  | UpdateBusinessCategoryFailure
  | FetchBusinessCategoriesSuccess
  | FetchBusinessCategoriesFailure
  | FetchBusinessCategoriesRequest
  | FetchBusinessCategorySuccess
  | FetchBusinessCategoryFailure
  | FetchBusinessCategoryRequest
  | CreateBusinessCategoryRequest
  | CreateBusinessCategorySuccess
  | CreateBusinessCategoryFailure
  | DeleteBusinessCategoryRequest
  | DeleteBusinessCategorySuccess
  | DeleteBusinessCategoryFailure
  | CreateBusinessSubcategoryRequest
  | CreateBusinessSubcategorySuccess
  | CreateBusinessSubcategoryFailure
  | DeleteBusinessSubcategoryRequest
  | DeleteBusinessSubcategorySuccess
  | DeleteBusinessSubcategoryFailure
  | FetchBusinessSubcategoryRequest
  | FetchBusinessSubcategorySuccess
  | FetchBusinessSubcategoryFailure
  | UpdateBusinessSubcategoryRequest
  | UpdateBusinessSubcategorySuccess
  | UpdateBusinessSubcategoryFailure
  | SetDefaultData
  | UpdateField
